import React from 'react';
import Navbar from '../Layout/Navbar';
import './Legal.css';

const PrivacyPolicy: React.FC = () => (
  <div className="legal-page">
    <Navbar />
    <div className="legal-container">
      <h1>Privacy Policy</h1>
      <p className="legal-updated">Last updated: March 2026</p>

      <section>
        <h2>What We Collect</h2>
        <p>When you connect your Strava account, we receive your name, email address, profile photo, and activity data (runs, workouts) from Strava. We store this information to power your training plan and AI coaching experience.</p>
        <p>We also collect usage data such as your race goals, planned workouts, and coach conversation history to personalise your training recommendations.</p>
      </section>

      <section>
        <h2>How We Use Your Data</h2>
        <ul>
          <li>To generate and adapt your training plan</li>
          <li>To provide AI coaching responses personalised to your fitness</li>
          <li>To sync your completed workouts from Strava</li>
          <li>To display race information and recommendations</li>
        </ul>
        <p>We do not sell your personal data to third parties.</p>
      </section>

      <section>
        <h2>Strava Integration</h2>
        <p>We connect to Strava using OAuth 2.0. We request read-only access to your activities. You can revoke our access at any time from your <a href="https://www.strava.com/settings/apps" target="_blank" rel="noopener noreferrer">Strava settings</a>.</p>
      </section>

      <section>
        <h2>Data Storage</h2>
        <p>Your data is stored securely on Railway infrastructure (PostgreSQL database). We use HTTPS for all data in transit.</p>
      </section>

      <section>
        <h2>Your Rights</h2>
        <p>You can request deletion of your account and all associated data at any time by contacting us. We will process deletion requests within 30 days.</p>
      </section>

      <section>
        <h2>Cookies</h2>
        <p>We use a single session cookie to keep you logged in. We do not use tracking or advertising cookies.</p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>Questions about your privacy? <a href="/contact">Contact us</a> and we'll respond within 5 business days.</p>
      </section>
    </div>
  </div>
);

export default PrivacyPolicy;
